import ArrowLeft from "assets/svg/arrow-left.svg";
import Clock from "assets/svg/clock.svg";
import Profile from "assets/svg/newCourses/profile.svg";
import Button from "components/Button";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { FC } from "react";
import { commafy, convertToJalali, getClassFormat } from "src/utils";

type Props = {
  color: string | undefined;
  image: string | undefined;
  id: string | undefined | number;
  title: string | undefined;
  percent: string | undefined | number;
  price: string | undefined | number;
  priceWidoutDiscount: number | undefined;
  discount: number | undefined;
  courseType: string | undefined;
  seoUrlDescription: string | undefined;
  date: string | undefined;
  isBuyable: boolean;
  type?: string;
  teacherNames: string | undefined;
};
const Index: FC<Props> = ({
  color,
  image,
  id,
  discount,
  title,
  percent,
  price,
  courseType,
  date,
  teacherNames,
  type,
  seoUrlDescription,
  isBuyable,
}) => {
  const { push } = useRouter();

  // const handleCardClick = (id: number) => {
  //     type == 'packege-details'
  //         ? push(`/course/${id}`, {
  //               pathname: seoUrlDescription
  //                   ? `/course/${id}/${seoUrlDescription}`
  //                   : `/course/${id}`,
  //           })
  //         : push(`/package-details/${id}`, {
  //               pathname: seoUrlDescription
  //                   ? `/package-details/${id}/${seoUrlDescription}`
  //                   : `/package-details/${id}`,
  //           });
  // };
  return (
    <div
      style={{
        contain: "content",
        borderColor: color,
      }}
      className="relative flex w-full cursor-pointer flex-col overflow-hidden rounded-lg bg-white pb-20 shadow xl:h-auto xl:pb-16"
    >
      <Link
        href={
          type == "packege-details"
            ? {
                href: `/course/${id}`,
                pathname: seoUrlDescription
                  ? `/course/${id}/${seoUrlDescription}`
                  : `/course/${id}`,
              }
            : {
                href: `/package-details/${id}`,
                pathname: seoUrlDescription
                  ? `/package-details/${id}/${seoUrlDescription}`
                  : `/package-details/${id}`,
              }
        }
      >
        <a>
          <div
            // onClick={() => handleCardClick(id as number)}
            className="flex h-[137px] w-full items-center justify-between"
          >
            {/*{image ? (*/}
            {/*  <Image*/}
            {/*    src={image}*/}
            {/*    className="h-full w-full object-cover"*/}
            {/*    height={137}*/}
            {/*    width={200}*/}
            {/*    alt="laptop 333"*/}
            {/*  />*/}
            {/*) : undefined}*/}
            <img
              loading="lazy"
              src={image}
              className="h-full w-full object-cover"
              height={137}
              alt="laptop 333"
            />
          </div>
        </a>
      </Link>
      <Link
        href={
          type == "packege-details"
            ? {
                href: `/course/${id}`,
                pathname: seoUrlDescription
                  ? `/course/${id}/${seoUrlDescription}`
                  : `/course/${id}`,
              }
            : {
                href: `/package-details/${id}`,
                pathname: seoUrlDescription
                  ? `/package-details/${id}/${seoUrlDescription}`
                  : `/package-details/${id}`,
              }
        }
      >
        <a className="top-0 z-10 flex h-full flex-auto flex-col justify-between pt-4 text-black-450 xl:pt-7">
          <div className="px-3 text-sm  sm:px-5">
            <p className="overflow-ellipsis text-lg">{title}</p>
            <div className="my-7 space-y-3 text-xs text-[#999696]">
              {type !== "packege-details" && (
                <div className="flex">
                  <Clock className="ml-2 fill-[#999696]" />
                  <p>{date && convertToJalali(date as any)}</p>
                </div>
              )}
              {teacherNames && (
                <div className="flex">
                  <Profile className="ml-2 fill-[#999696]" />
                  <p>{teacherNames}</p>
                </div>
              )}
            </div>
          </div>
          <div className="my-0 flex w-full items-center justify-between px-3 sm:px-5">
            <div className="flex md:flex-col 4xl:flex-row">
              {isBuyable && price == 0 ? (
                "رایگان"
              ) : isBuyable ? (
                <>
                  <span className="ml-1 whitespace-nowrap text-base 2xl:ml-3">
                    {discount !== null && discount !== 0
                      ? commafy(discount)
                      : commafy(price)}{" "}
                    تومان
                  </span>
                  {discount !== null && discount !== 0 && (
                    <span className="flex items-center whitespace-nowrap text-sm line-through">
                      {price && commafy(price)} تومان
                    </span>
                  )}
                </>
              ) : null}
            </div>
            {type !== "packege-details" ? (
              <Button
                style={{ background: color }}
                className="rounded-lg py-2 px-3 text-white  sm:px-5"
              >
                خرید
              </Button>
            ) : (
              <Button
                style={{ background: color }}
                className="rounded-full p-2"
              >
                <ArrowLeft />
              </Button>
            )}{" "}
          </div>
          <span className="absolute bottom-2 right-2 text-sm text-white">
            {type !== "packege-details" && `${percent} %`}{" "}
            {getClassFormat(courseType as any)}
          </span>
        </a>
      </Link>
      <div
        style={{
          clipPath: "polygon(100% 79%, 100% 100%, 0 100%, 0 86%)",
          background: color,
        }}
        className="absolute left-0 bottom-0 flex h-40 w-full"
      ></div>
      <div
        style={{
          clipPath: "polygon(100% 90%, 100% 100%, 0 100%, 0 78%)",
          background: color,
        }}
        className="absolute left-0 bottom-0 flex h-44 w-full opacity-20"
      />
    </div>
  );
};

export default Index;
